import { Switch } from "antd";

const HeaderToggle = ({ isEnabled, setIsEnabled }) => {
  return (
    <div className="d-flex align-items-center justify-content-between">
      <p className="text-muted">Configurer l'authentification à double facteur</p>

      <div
        className={`switch ${isEnabled ? "active" : ""}`}
        onClick={() => setIsEnabled((prev) => !prev)}
      >
        <div className="switch-circle">
          <Switch
            checkedChildren="Activer"
            unCheckedChildren="Désactiver"
            checked={isEnabled}
          />
        </div>
      </div>
    </div>
  );
};

export default HeaderToggle;
